import { ref } from 'vue'

const showLocaleModal = ref(false)

export function useLocaleModal() {
  const openLocaleModal = () => {
    showLocaleModal.value = true
  }

  const closeLocaleModal = () => {
    showLocaleModal.value = false
  }

  return {
    showLocaleModal,
    openLocaleModal,
    closeLocaleModal,
  }
}
